import api from "./api";

export const getSupportConfig = () =>
    api.get("/config/support");
